export const iconFontAwesomeSciencefictionGalacticRepublic = (
	<i className="fa-solid fa-galactic-republic"></i>
);
